
import * as types from '../constants/actionTypes';

const initialState = {
    message_log :[],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case types.INVENTORY_LIST_SUCCESS: {
            return {
                ...state,
                inventories: action.payload,
            };
        }
        case types.INVENTORY_LIST_FAIL: {
            return {
                ...state,
                inventories: [],
                errors : {
                    error: action.error,
                },
            };
        }
        default: return state;
    }
};
